import api from './BaseApi';
import axios from 'axios';

export default {
  register(data) {
    return api.post('user/register', data);
  },
  getUser() {
    return api.get('user', undefined, { timeout: 12000 });
  },
  startUserRead() {
    const source = axios.CancelToken.source();
    return { promise: api.get('user', undefined, { timeout: 12000, cancelToken: source.token }), cancel: source.cancel };
  },
  login(payload) {
    return api.post('user/login', payload, { timeout: 12000 })
  },
  logout() {
    return api.post('user/logout');
  },
  saveProfile(data) {
    return api.post('profile/add', data);
  },
  updateProfile({ id, ...profile }) {
    return api.post(`profile/${id}/edit`, profile);
  },
  updateUser(user) {
    return api.post(`user/update`, user);
  },
  uploadAvatar(profileId, avatar) {
    let formData = new FormData();
    formData.append('image', avatar, avatar.name);
    return api.post(`profile/${profileId}/avatar/replace`, formData);
  },
  deleteProfile(profileId) {
    return api.post(`profile/${profileId}/delete`);
  },
  prefetch() {
    // return Promise.all([api.get('updateWeek'), api.get('updateWeekSet')]);
  }
};
